window.lazySizesConfig = window.lazySizesConfig || {};
window.lazySizesConfig.init = false;
window.lazySizesConfig.loadMode = 1;
window.lazySizesConfig.loadHidden = false;
window.lazySizesConfig.preloadAfterLoad = false;

window.lazySizes = require('lazysizes');

setTimeout(function () {
    window.lazySizes.init();
}, 200);
